<script>
    import { onMount } from "svelte";
    import { get } from 'svelte/store';
    import { raumItems } from '../../store.js';
    let settingItems = $raumItems;

    function onChange(index) {
        const file = settingItems[index].input.files[0];
        if (file) {
            const reader = new FileReader();
            reader.addEventListener("load", function () {
                settingItems[index].image = reader.result;
            });
            reader.readAsDataURL(file);                
            return;
        }
    }

    function addRow() {
        settingItems = settingItems.concat({name:'', quantity: '', image: ''})
    }

    function deleteRow(i) {
        if(settingItems.length <= 1) return;
        
        settingItems = [
			...settingItems.slice(0, i),
			...settingItems.slice(i + 1, settingItems.length)
		];;
    }

    function deleteAll() {
        if(confirm('정말로 전체 삭제?')) {
            settingItems = [{name: '', quantity: '', image: ''}];
        }
    }

    function rollBack() {
        settingItems = $raumItems;
    }

    function save() {
        raumItems.set(settingItems)
        alert('저장되었습니다');
    }
</script>


<h1 style="text-align:center">설정</h1>

{#each settingItems as item, i}
    <div class="row">
        <h3>{i+1}</h3>
        <div class="content">
            <label>이름</label>
            <input type="text" bind:value={item.name} />
            <label>수량</label>
            <input type="number" bind:value={item.quantity} />
            <label>이미지</label>
            <div>
                <input
                    bind:this={item.input}
                    on:change={()=>onChange(i)}
                    type="file"
                />
                <img src={item.image} alt="Preview" />  
            </div> 
            <label>액션</label>
            <div style="text-alight:right;">
                <button on:click={()=>deleteRow(i)}>삭제</button>
            </div>
        </div>
    </div>
{/each}

<div class="add-bar">
    <button on:click={addRow}>추가</button>
</div>

<div class="action-bar">
    <button on:click={deleteAll}>전체삭제</button>
    <button on:click={save}>저장</button>
</div>


<style>
    .add-bar button {
        width: 100%;
    }
    .action-bar {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }
    .row {
        border: 1px solid black;
    }
    .content {
      display: grid;
      grid-template-columns: 20% 80%;
      grid-column-gap: 10px;
    }

    .content img {
        width: 200px;
        object-fit: contain;
    }
</style>

